angular.module('contentful').directive('cfEntryEditor', [
  'require',
  require => {
    const createEditorController = require('app/entity_editor/EntryController.es6').default;
    return {
      restrict: 'E',
      scope: {
        entryId: '<',
        preferences: '<'
      },
      template: JST.entry_editor(),
      controller: ['$scope', $scope => createEditorController($scope, $scope.entryId)]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/javascripts/app/entry_editor/cf_entry_editor_directive.js